// eslint-disable-next-line import/no-anonymous-default-export
export default {
  Coder: "Coder",
  Member: "Member",
  Manager: "Manager",
  TeamLead: "Team Lead",
  Admin: "Admin",
};
